<template>
    <div class="input-group pb-4">
        <select name="xero_guid" class="form-control" v-model="contact" @change="save">

            <option value="" disabled>Select contact</option>

            <option v-for="xeroContact in xeroContacts" :value="xeroContact.ContactID">
                {{xeroContact.Name}}
            </option>
        </select>
        <span v-if="loading !== null" class="input-group-text">
            <div v-if="loading === true" class="spinner-border spinner-border-sm text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            <i v-else class="fa fa-check"></i>
        </span>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        route: String,
        setting: Object,
        xeroContacts: Object,
    },
    data () {
        return {
            loading: null,
            contact: this.setting.value
        };
    },
    methods: {
        save () {
            this.loading = true;
            axios.post(
                this.route,
                {
                    name: this.setting.name,
                    value: this.contact,
                }
            ).then((response) => {
                if (response.data.success !== true) {
                    throw new Error('unable to save');
                }

                this.loading = false;
                setTimeout(() => {
                    this.loading = null;
                }, 1000);
            }).catch((error) => {
                this.invalid = true;
                this.loading = null;
                let status = 'Unknown';
                if (error.response) {
                    status = error.response.status;
                    if (status === 422) {
                        return;
                    }
                }
                Swal.fire({
                    icon: 'error',
                    title: 'Could not update setting',
                    text: 'System error: ' + status,
                });
            });
        },
    }
}
</script>
